import { render, staticRenderFns } from "./AutoCheckCompanionUpsell.vue?vue&type=template&id=678137d8&"
import script from "./AutoCheckCompanionUpsell.vue?vue&type=script&lang=js&"
export * from "./AutoCheckCompanionUpsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports